import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React, { createContext, useReducer } from 'react';

const SHOW_TOAST = 'SHOW_TOAST';
const HIDE_TOAST = 'HIDE_TOAST';
const SET_MESSAGE = 'SET_MESSAGE';
const SET_TYPE = 'SET_TYPE';

export const GenericSnackBarContext = createContext(null);

const initialState = {
  open: false,
  message: '',
  duration: 5000,
  severity: 'error',
  vertical: 'top',
  horizontal: 'center',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_TOAST:
      return {
        ...state,
        open: true,
      };
    case HIDE_TOAST:
      return {
        ...state,
        message: '',
        open: false,
      };
    case SET_MESSAGE:
      return {
        ...state,
        ...action.payload,
      };
    case SET_TYPE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

const showToastAction = () => ({
  type: SHOW_TOAST,
});

const hideToastAction = () => ({
  type: HIDE_TOAST,
});

const setMessageAction = (message) => ({
  type: SET_MESSAGE,
  payload: {
    message,
  },
});

const setTypeAction = (severity) => ({
  type: SET_TYPE,
  payload: {
    severity,
  },
});

const GenericSnackBarContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { open, message, severity, vertical, horizontal, duration } = state;

  const Toast = (obj = { message: '', type: 'error' }) => {
    dispatch(showToastAction());
    dispatch(setMessageAction(obj.message));
    dispatch(setTypeAction(obj.type));
  };

  const SuccessToast = (message) => Toast({ message, type: 'success' });
  const ErrorToast = (message) => Toast({ message, type: 'error' });
  const WarningToast = (message) => Toast({ message, type: 'warning' });
  const handleClose = () => dispatch(hideToastAction());

  return (
    <GenericSnackBarContext.Provider
      value={{ SuccessToast, ErrorToast, WarningToast }}>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        autoHideDuration={duration}
        onClose={handleClose}>
        <Alert severity={severity}>{message}</Alert>
      </Snackbar>
      {children}
    </GenericSnackBarContext.Provider>
  );
};

export default GenericSnackBarContextProvider;
